export let SignupInterestActionTypes;

(function (SignupInterestActionTypes) {
  SignupInterestActionTypes["SubmitForm"] = "[Signup Interest] Submit Form";
})(SignupInterestActionTypes || (SignupInterestActionTypes = {}));